import { MainView } from "views/layout/MainView";
import { WorkspaceSearchField } from "./pages/WorkspaceConversation.tsx/InfoComponent/WorkspaceSearchField";
import { HistoryList } from "./pages/WorkspaceConversation.tsx/Threads/Components/HistoryList";
import { useWindowSize } from "hooks/useWindowSize";
import { useSidebar } from "hooks/services/ReSizeSidebar";
import classNames from "classnames";
import styles from "./pages/WorkspaceConversation.tsx/workSpaceConversation.module.scss";
import { useSelector } from "redux/hooks";
import { UploadedFilePreview } from "./pages/WorkspaceConversation.tsx/Threads/Components/UploadedFilePreview";
import { useFileUpload } from "hooks/useFileUpload"; 
import { useMemo, useState } from "react";
import { ChatType, setSearchActive, EmptyThreadChat, EmptyCurrentChat, EmptyUploadedFiles, setChatModel, startNewChat, EmptyChatContent,setRememberChatTopic } from "redux/actions";
import { useThreadsHistoryContext } from "hooks/ThreadHistoryContext";
import _ from "lodash";
import { ChatSettingModal } from "pages/ChatPage/components/chatSettingModal";
import useRouter from "hooks/useRouter";
import { DragDropModal } from "./pages/WorkspaceConversation.tsx/Component/Drag&DropModal";
import { ErrorHandler } from "./components/ErrorHandler/ErrorHandler";
import { RoutePaths } from "pages/routePaths";
import { useEffectOnce } from "react-use";
import { EmptyObj } from "utils/fileProcessing";
const ResetcurrentConversation = {
  id: 0,
  created_at: "",
  description: "",
  instructions: "",
  name: "",
  settings: "",
  team_id: 0,
  updated_at: "",
  emoji: "",
};

export const HomePage = () => {
  const { push } = useRouter();
  const { width } = useWindowSize();
  const { sidebarWidth } = useSidebar();
  const { isModalOpen, isSearchActive } = useSelector(
    (state) => state.workSpaceReducer
  );
  const { gptModel } = useSelector((state) => state.authReducer);
  const { openUploadURLModel } = useSelector((state) => state.workSpaceReducer);
  const { chatModels } = useSelector((state) => state.chatModelsReducer);

  const [isDrag, setIsDrag] = useState<boolean>(false);

  const { errorModal, setErrorModal, messageId, setMessageId, handleDrop } =
    useFileUpload(false);

    useEffectOnce(() => {
      const GPTModal = localStorage.getItem("GptModel");
      if (GPTModal && GPTModal !== "undefined") {
        const gptModel = JSON.parse(GPTModal);
        setChatModel(gptModel);
      } else if (
        gptModel?.type?.includes(ChatType.image) &&
        !gptModel?.type?.includes(ChatType.image_chat)
      ) {
        setChatModel(chatModels[0]);
      }
      EmptyChatContent();
      startNewChat();
      EmptyThreadChat(EmptyObj);
      EmptyCurrentChat(ResetcurrentConversation);
      EmptyUploadedFiles();
      setRememberChatTopic("");
    })
    
  const {
    isAnswerComplete,
    sizeMessage,
    chatSettings,
    setChatSetting,
    settings,
    setSettings,
    loadingSetting,
  } = useThreadsHistoryContext();

  const isAllowUploadFile = useMemo(() => {
    if (gptModel?.type.includes(ChatType.image) && !gptModel?.type?.includes("image_chat")) {
      return false;
    }

    if (openUploadURLModel) {
      return false;
    }

    if (isModalOpen) return true;
    return true;
  }, [gptModel ]);

  return (
    <div>
      <MainView
        setIsDrag={setIsDrag}
        isAnswerComplete={isAnswerComplete}
        isAllowUploadFile={isAllowUploadFile}
        setChatSetting={setChatSetting}
      >
        <div className="flex justify-center items-center w-full">
        <div
          className={classNames(`flex flex-col mt-[31px] flex-0 gap-[20px] ${width <= 1024 ? "w-full" : "w-[64%]"}`,
            {
              [styles.HomeConversationContainer]:
                (sidebarWidth > 287 && width <= 1150) ||
                (sidebarWidth > 497 && width <= 1323) ||
                (sidebarWidth > 480 && width <= 1305),
              "pr-[19px] pl-[15px]": width < 576,
            }
          )}
        >
          <div
            className={` ${width < 576 ? "w-[100%] pl-[0%]" : "w-[92%] pl-[8%]"}`}
          >
            <div className={classNames(
              styles.searchFieldWrapper,
              { [styles.hidden]: isSearchActive }
            )}>
                <div className={classNames(
                  styles.searchFieldContent,
                  { [styles.hidden]: isSearchActive }
                )}>
                {(!isModalOpen) && <UploadedFilePreview />}
              <WorkspaceSearchField conversation={true} homePage={true} />
              </div>
            </div>
          </div>
          <div>
          <div className={classNames(
           width > 576 && width <= 1024 ? "px-[2rem]" : "px-0",
            styles.historyListWrapper,
            { [styles.searchActive]: isSearchActive }
          )}>
            {" "}
            <HistoryList
              onSearchFocus={() => setSearchActive(true)}
              onSearchBlur={() => setSearchActive(false)}
            />{" "}
            </div>
          </div>
        </div>
        </div>
      </MainView>

      {isDrag && (
        <DragDropModal
          handleClose={() => setIsDrag(false)}
          handleDrop={async (event: React.DragEvent<HTMLDivElement>) => {
            await handleDrop(event, openUploadURLModel ? false : isModalOpen);
          }}
        />
      )}

      {chatSettings && (
        <ChatSettingModal
          onClose={() => setChatSetting(false)}
          loadingSetting={loadingSetting}
          settings={settings}
          setSettings={setSettings}
        />
      )}
      <ErrorHandler
        errorModal={errorModal}
        setErrorModal={setErrorModal}
        messageId={messageId ? messageId : sizeMessage}
        onConfirm={() =>
          push(`/${RoutePaths.Settings}/${RoutePaths.CurrentPlan}`)
        }
        onCancel={() => setMessageId("")}
      />
    </div>
  );
};
